import React from 'react';

import { Accordion } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';

import '../css/Components.css';

const SECTIONS = [
	{
		key: 'noun',
		title: 'noun',
		options: [
			{ value: 'f',        label: 'feminine noun' },
			{ value: 'm',        label: 'masculine noun' },
			{ value: 'n',        label: 'neuter noun' },
			{ value: 'mf',       label: 'masculine and feminine noun' },
			{ value: 'mn',       label: 'masculine and neuter noun' },
			{ value: 'f_pn',     label: 'feminine proper noun' },
			{ value: 'm_pn',     label: 'masculine proper noun' },
			{ value: 'n_pn',     label: 'neuter proper noun' },
			{ value: 'card_num', label: 'cardinal number' },
			{ value: 'ppf_actn', label: 'periphrastic perfect action noun' },
		],
	},
	{
		key: 'pron',
		title: 'pronoun',
		options: [
			{ value: 'pron',       	   label: 'pronoun' },
			{ value: 'dem_pron',       label: 'demonstrative pronoun' },
			{ value: 'int_pron',       label: 'interrogative pronoun' },
			{ value: 'pers_pron',      label: 'personal pronoun' },
			{ value: 'reflexive_pron', label: 'reflexive pronoun' },
			{ value: 'rel_pron',       label: 'relative pronoun' },
		],
	},
	{
		key: 'adj',
		title: 'adjective',
		options: [
			{ value: 'adj',      label: 'adjective' },
			{ value: 'dem_adj',  label: 'demonstrative adjective' },
			{ value: 'int_adj',  label: 'interrogative adjective' },
			{ value: 'pron_adj', label: 'pronominal adjective' },
			{ value: 'rel_adj',  label: 'relative adjective' },
			{ value: 'ord_num',  label: 'ordinal number' },
		],
	},
	{
		key: 'adv',
		title: 'adverb',
		options: [
			{ value: 'adv',      label: 'adverb' },
			{ value: 'dem_adv',  label: 'demonstrative adverb' },
			{ value: 'int_adv',  label: 'interrogative adverb' },
			{ value: 'pron_adv', label: 'pronominal adverb' },
			{ value: 'rel_adv',  label: 'relative adverb' },
		],
	},
	{
		key: 'pcl',
		title: 'particle',
		options: [
			{ value: 'pcl',      label: 'particle' },
			{ value: 'conj_pcl', label: 'conjunctive particle' },
			{ value: 'disj_pcl', label: 'disjunctive particle' },
			{ value: 'neg_pcl',  label: 'negative particle' },
			{ value: 'sub_pcl',  label: 'subordinating particle' },
			{ value: 'preverb',  label: 'preverb' },
		],
	},
];

const LexNominal = ({ inputParts, setInputParts }) => {
	const updateInput = (key, value) => {
		setInputParts((prev) => ({ ...prev, [key]: value }));
	};

	const selected = inputParts['lexical_category'];

	return (
		<Accordion defaultActiveKey="noun" flush>
			{SECTIONS.map(({ key, title, options }) => (
				<Accordion.Item eventKey={key} key={key}>
					<Accordion.Header>{title}</Accordion.Header>
					<Accordion.Body>
						<Form.Group>
							{options.map(({ value, label }) => (
								<Form.Check
									key={value}
									id={`lex_nom_${value}`}
									type="radio"
									name="lexNominalCategory"
									label={
										<span className="lex-radio-label">
											<span className="lex-radio-code">{value}</span>
											<span className="lex-radio-text">{label}</span>
										</span>
									}
									checked={selected === value}
									onChange={() => updateInput('lexical_category', value)}
								/>
							))}
						</Form.Group>
					</Accordion.Body>
				</Accordion.Item>
			))}
		</Accordion>
	);
};

export default LexNominal;
